import React, { useEffect, useState } from "react"
import { usePageContext } from "vike-react/usePageContext"
import { navigate } from "vike/client/router"
import Spinner from "../ui/Spinner"
import useT from "../hooks/useT"
import useClientAuth from "../hooks/useClientAuth"
import useSiteLanguage from "../hooks/useSiteLanguage"
import { usePageTitle } from "../hooks/usePageTitle"
import { StoreProducts, refreshStoreAccount } from "../storeApi"

const sleep = (ms) => new Promise((r) => setTimeout(r, ms))

/**
 * /success — after a subscription checkout: polls store {products
 * user-subscriptions} until the subscription is active, refreshes the
 * account and continues to /user/welcome (old Plans/success.jsx).
 */
export default function SuccessPage() {
  const t = useT()
  const language = useSiteLanguage()
  const pageContext = usePageContext()
  const { auth } = useClientAuth()
  const [timedOut, setTimedOut] = useState(false)
  usePageTitle(t`Aldoo - Subscription Successful`)

  useEffect(() => {
    if (!auth?.auth_token) return
    let stopped = false
    ;(async () => {
      for (let i = 0; i < 120 && !stopped; i++) {
        const result = await StoreProducts({ category: "user-subscriptions", language, fields: ["subscription", "pid"] }).catch(() => null)
        const active = Array.isArray(result?.products) && result.products.find((s) => s.subscription?.active)
        if (active) {
          await refreshStoreAccount()
          navigate(`/user/welcome${pageContext.urlParsed?.searchOriginal || ""}`)
          return
        }
        await sleep(1000)
      }
      if (!stopped) setTimedOut(true)
    })()
    return () => {
      stopped = true
    }
  }, [auth?.auth_token])

  return (
    <div className="w-full flex h-[50vh] items-center justify-center px-4" data-testid="subscription-success">
      <div className="flex flex-col items-center gap-4 text-center">
        <h2 className="m-0 text-[24px] md:text-[28px] font-bold">{timedOut ? t`Welcome aboard!` : t`Creating your subscription...`}</h2>
        {!timedOut && <Spinner className="py-4" />}
      </div>
    </div>
  )
}
